import HeroImage from '../components/HeroImage/HeroImage'
import Lines from '../components/Lines/Lines'
import About from '../components/About/About'
import OurPhilosophy from '../components/OurPhilosophy/OurPhilosophy'
import Medicine from '../components/Medicine/Medicine'
import MisionVision from '../components/MisionVision/MisionVision'
import History from '../components/History/History'
import { HomeContainer, SectionsContainer } from '../styles/Layout.style'

const Home = () => {
    return(
      <HomeContainer>
       <HeroImage />
       <Lines />
       <About />
       <SectionsContainer>
        <OurPhilosophy />
        <Medicine />
        <MisionVision />
       </SectionsContainer>
       <History />
      </HomeContainer>
    )
}

export default Home